export const AuthenticationState = _ => ({
  multifactorAuthenticationSettings: {},
})
